import { createFileRoute } from "@tanstack/react-router";

import { PagesPage } from "../../../../features/storefront/pages-page";

export const Route = createFileRoute("/_app/settings/pages/")({ component: PagesPage });
